import { EDITOR_APPEARANCE_CONTEXT } from '@atlaskit/analytics-namespaced-context';
export const getAnalyticsAppearance = appearance => {
  switch (appearance) {
    case 'full-page':
      return EDITOR_APPEARANCE_CONTEXT.FIXED_WIDTH;

    case 'full-width':
      return EDITOR_APPEARANCE_CONTEXT.FULL_WIDTH;

    case 'comment':
      return EDITOR_APPEARANCE_CONTEXT.COMMENT;

    case 'chromeless':
      return EDITOR_APPEARANCE_CONTEXT.CHROMELESS;

    case 'mobile':
      return EDITOR_APPEARANCE_CONTEXT.MOBILE;
  }
};
export const getAnalyticsEventSeverity = (duration, normalThreshold, degradedThreshold) => {
  if (duration > normalThreshold && duration <= degradedThreshold) {
    return SEVERITY.DEGRADED;
  }

  if (duration > degradedThreshold) {
    return SEVERITY.BLOCKING;
  }

  return SEVERITY.NORMAL;
};
export let SEVERITY;

(function (SEVERITY) {
  SEVERITY["NORMAL"] = "normal";
  SEVERITY["DEGRADED"] = "degraded";
  SEVERITY["BLOCKING"] = "blocking";
})(SEVERITY || (SEVERITY = {}));

export { UNSUPPORTED_CONTENT_LEVEL_SEVERITY, getUnsupportedContentLevelData, UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS } from './unsupportedContent/get-unsupported-content-level-data';
export let EVENT_TYPE;

(function (EVENT_TYPE) {
  EVENT_TYPE["TRACK"] = "track";
  EVENT_TYPE["UI"] = "ui";
})(EVENT_TYPE || (EVENT_TYPE = {}));

export let ACTION;

(function (ACTION) {
  ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncountered";
  ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
})(ACTION || (ACTION = {}));

export let ACTION_SUBJECT;

(function (ACTION_SUBJECT) {
  ACTION_SUBJECT["DOCUMENT"] = "document";
  ACTION_SUBJECT["TOOLTIP"] = "tooltip";
})(ACTION_SUBJECT || (ACTION_SUBJECT = {}));

export let ACTION_SUBJECT_ID;

(function (ACTION_SUBJECT_ID) {
  ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
  ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
  ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
  ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
  ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
  ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
  ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
})(ACTION_SUBJECT_ID || (ACTION_SUBJECT_ID = {}));

export const analyticsEventKey = 'EDITOR_ANALYTICS_EVENT';